module.exports = __webpack_public_path__ + "img/facebook.5cea7e38.svg";